import { StrictMode, createRoot } from "@wordpress/element";
import ScrollEntidades from "./ScrollEntidades";

// Mount the component to the 'root' div
const root = document.getElementById('scroll-entidades');
if (root) {
  const filterEntidades = root.getAttribute('data-filter');
  
  createRoot(root).render(
    <StrictMode>
      <ScrollEntidades filterEntidades={filterEntidades} />
    </StrictMode>
  );
}
